import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

// eslint-disable-next-line react/prop-types
const SingleHeaderText = ({children}) => (
  <Typography variant="caption" fontWeight="bold" textTransform="uppercase" color="text.secondary">
    {children}
  </Typography>
);

const ParametersHeader = () => (
  <Grid
    container
    alignItems="center"
    gap={{xs: 3, md: 2}}
    sx={{
      display: {xs: 'none', md: 'flex'},
      borderBottom: theme => `2px solid ${theme.palette.divider}`,
      pb: 1,
      mb: 0.5
    }}
  >
    <Grid item md={5}>
      <SingleHeaderText>Paramètre</SingleHeaderText>
    </Grid>
    <Grid item md={4}>
      <SingleHeaderText>Valeur actuelle</SingleHeaderText>
    </Grid>
    <Grid item md>
      <SingleHeaderText>Description</SingleHeaderText>
    </Grid>
  </Grid>
);

export default ParametersHeader;
